const TOKEN_KEY = "sm_token";
const REMEMBER_EMAIL_KEY = "sm_remember_email";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY) || "";
}

export function setToken(token, rememberDevice = false) {
  clearToken();
  const storage = rememberDevice ? localStorage : sessionStorage;
  storage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
}

export function saveRememberedEmail(email, rememberDevice = false) {
  if (rememberDevice && email) {
    localStorage.setItem(REMEMBER_EMAIL_KEY, email);
  } else {
    localStorage.removeItem(REMEMBER_EMAIL_KEY);
  }
}

export function getRememberedEmail() {
  return localStorage.getItem(REMEMBER_EMAIL_KEY) || "";
}

export function hasRememberedSession() {
  return !!localStorage.getItem(TOKEN_KEY);
}
